export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_09.94585984.jpg";